module.exports = __webpack_public_path__ + "img/8_42.7db67b0e.png";